import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import styles from './Modal.module.scss';

export const ModalComponent = ({ open, onClose, children, className }) => {
  return (
    <div>
      <Modal open={open} onClose={onClose} center classNames={{ modal: `${styles.modal} ${className}` }}>
        {children}
      </Modal>
    </div>
  );
};
